module.exports = __webpack_public_path__ + "static/media/kid11.a01eb2ea.png";